import { useCallback, useRef } from 'react';
/**
 * Will return a tuple of the element and the callback ref to set.
 * This is used as a work around for using `useRef` directly with Typescript
 * as the types don't flow through as one would expect.
 */
export var useElementRef = function useElementRef() {
  var elementRef = useRef(null);
  var setRef = useCallback(function (ref) {
    elementRef.current = ref;
  }, []);
  return [elementRef.current, setRef];
};